const getValue = (value, fallback) => {
  const resolved = ko.toJS(value);
  return resolved === undefined ? fallback : resolved;
};

const normalizeAttrs = (value) => {
  const resolved = ko.toJS(value);
  if (!resolved) return {};
  return { ...resolved };
};

export class ViewModel {
  constructor(params) {
    this.label = params.label;
    this.icon = params.icon;
    this.collapsedIcon = params.collapsedIcon;
    this.disabled = params.disabled;
    this.tooltip = params.tooltip;
    this.collapsedTooltip = params.collapsedTooltip;
    this.effectiveTooltip = ko.computed(() => getValue(params.collapsedTooltip) || getValue(params.tooltip));
    this.extraClass = params.extraClass;
    this.iconOnly = ko.computed(() => Boolean(getValue(params.iconOnly, false)));
    this.iconPosition = ko.computed(() => getValue(params.iconPosition, "left"));
    this.variant = ko.computed(() => getValue(params.variant, "primary"));
    this.size = ko.computed(() => getValue(params.size, "md"));
    this.href = params.href;
    this.target = params.target;

    this.isLink = ko.computed(() => Boolean(getValue(params.href)));

    this.classes = ko.computed(() => {
      const classes = [
        "vap-button",
        `vap-button--${this.variant()}`,
        `vap-button--${this.size()}`,
      ];

      if (this.iconOnly()) classes.push("vap-button--icon-only");
      if (getValue(this.icon)) classes.push("vap-button--has-icon");
      if (this.iconPosition() === "right") classes.push("vap-button--icon-right");
      if (getValue(this.collapsedIcon)) classes.push("vap-button--collapsible");
      if (getValue(this.disabled)) classes.push("vap-button--disabled");

      const extraClass = getValue(this.extraClass, "");
      if (extraClass) classes.push(extraClass);

      return classes.join(" ");
    });

    this.linkAttrs = ko.computed(() => {
      const attrs = normalizeAttrs(params.attrs);
      if (getValue(this.disabled)) {
        delete attrs.href;
        delete attrs.target;
      } else {
        const href = getValue(params.href);
        const target = getValue(params.target);
        if (href) attrs.href = href;
        if (target) attrs.target = target;
      }
      const tooltip = getValue(this.collapsedTooltip) || getValue(this.tooltip);
      if (tooltip) attrs.title = tooltip;
      return attrs;
    });

    this.buttonAttrs = ko.computed(() => {
      const attrs = normalizeAttrs(params.attrs);
      attrs.type = getValue(params.type, "button");
      if (getValue(this.disabled)) attrs.disabled = true;
      const tooltip = getValue(this.collapsedTooltip) || getValue(this.tooltip);
      if (tooltip) attrs.title = tooltip;
      return attrs;
    });

    this.onClick = (_, event) => {
      if (getValue(this.disabled)) {
        event.preventDefault();
        return false;
      }
      if (typeof params.click === "function") {
        params.click(event);
      }
      return true;
    };
  }
}
